import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RailCar } from 'src/app/routes/search-cars-component/car-filter.helper';
import {
  CAR_TYPE,
  MarketPlaceQuoteRequestService,
} from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { REQUEST_STEPS } from '../enum-request-steps';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../services/mixpanel-service/mixpanel.service';
@Component({
  selector: 'app-your-selections',
  templateUrl: './your-selections.component.html',
  styleUrls: ['./your-selections.component.scss'],
})
export class YourSelections implements OnInit {
  quoteRequest: any;
  objMechanicalOptions: any;
  selectedCarType: any;
  selectedCars: RailCar[] = [];
  cardAttrList: any;
  displayReturnToSearch = false;
  enum_car_type = CAR_TYPE;
  fromNewBuilds = false;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private draftQuoteService: draftQuoteRequest,
    private mixpanelService: MixpanelService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (history.state && history.state.fromNewBuilds) {
      this.fromNewBuilds = true;
    } else if (localStorage.getItem('fromNewBuilds') === 'true') {
      this.fromNewBuilds = true;
    }
    const { cardAttrList, selectedCars } =
      this.quoteRequestService.getSelectedCarList();
    this.cardAttrList = cardAttrList;
    this.selectedCars = selectedCars;
    this.trackSelectedCarListEvent(this.selectedCars);
  }

  private trackSelectedCarListEvent(selectedCars: any): void {
    const modelDescList = selectedCars
      .map((car: any) => car.model_desc)
      .join(', ');
    this.mixpanelService.track({
      eventName: 'Selections',
      eventDisplayName: modelDescList,
      kpi: 'User Engagement',
      trigger: 'On Page Load',
      eventDefinition: 'User viewed the selected car list',
      propertyType: 'Event Property',
      propertyDefinition: 'Selected Car Attributes',
      additionalProperties: {
        parentEvent: 'Begin Quote',
      },
    });
  }

  cardRemoved({ car, selected }: { car: RailCar; selected: boolean }) {
    this.mixpanelService.track({
      eventName: 'Selection Removed',
      eventDisplayName: 'Rail Car Removed: ' + car.model_desc,
      kpi: 'User Engagement',
      trigger: 'On Card Removal',
      eventDefinition: 'User removed a rail car from the selection',
      propertyType: 'Event Property',
      propertyDefinition: 'Removed Car Model',
      additionalProperties: {
        parentEvent: 'Begin Quote',
      },
    });
    this.selectedCars = this.selectedCars.filter(
      (x) => x.model_id != car.model_id
    );
    this.quoteRequestService.setSelectedCarList(
      this.selectedCars,
      this.cardAttrList
    );
  }

  next() {
    this.selectedCarType = this.quoteRequestService.getSelectedCarType();
    if (
      this.selectedCarType === this.enum_car_type.GONDOLA ||
      this.selectedCarType === this.enum_car_type.OPEN_HOPPER
    ) {
      this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
      window.scrollTo(0, 0);
      this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.LEASING_OPTIONS);
    } else {
      this.quoteRequestService.setNextStep(REQUEST_STEPS.MECHANICAL_OPTIONS);
      window.scrollTo(0, 0);
      this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.MECHANICAL_OPTIONS);
    }
  }

  navigateHome() {
    if (this.fromNewBuilds) {
      this.router.navigate(['/new-builds'], {
        state: { refresh: true },
      });
    } else {
      this.router.navigate(['/search-inventory/search-cars'], {
        state: { refresh: true },
      });
    }
  }

  showBackModal() {
    this.displayReturnToSearch = true;
  }
}
